import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SVG from 'components/renderSvg';
import lockIcon from 'media/svgs/lock.svg';
import Button from 'components/button';

const LimitReachedModal = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const handleLimitReached = (event) => {
            setErrorMessage(event.detail?.message || "You've reached the limit of your current plan.");
            setIsOpen(true);
        };

        window.addEventListener('limit-reached', handleLimitReached);
        return () => window.removeEventListener('limit-reached', handleLimitReached);
    }, []);

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm animate-in fade-in duration-200">
            <div className="bg-white rounded-[24px] shadow-2xl max-w-md w-full p-8 flex flex-col items-center text-center animate-in zoom-in-95 duration-200">
                <div className="w-20 h-20 bg-amber-50 rounded-full flex items-center justify-center mb-6">
                    <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center">
                        <SVG icon={lockIcon} className="w-6 h-6 text-amber-600" />
                    </div>
                </div>

                <h2 className="text-2xl font-bold text-gray-900 mb-2">Limit Reached</h2>
                <p className="text-gray-500 mb-8 leading-relaxed">
                    {errorMessage || "You've reached the limit of the Free Plan (1 Service, 2 Batches)."}
                    <br />
                    <span className="font-medium text-gray-700">Upgrade to Pro for unlimited access.</span>
                </p>

                <div className="flex flex-col w-full gap-3">
                    <Button
                        title="Upgrade to Pro"
                        variant="success"
                        className="w-full py-4 text-lg"
                        onClick={() => {
                            setIsOpen(false);
                            navigate('/plans');
                        }}
                    />
                    <button
                        onClick={() => setIsOpen(false)}
                        className="text-gray-400 hover:text-gray-600 font-medium py-2 transition-colors"
                    >
                        Maybe later
                    </button>
                </div>
            </div>
        </div>
    );
};

export default LimitReachedModal;
